import {
  useVersionUpdatedSubscription,
  VersionListItemFragment,
  VersionListItemFragmentDoc,
} from '@sketch/gql-types'
import { dataIdFromObject } from '@sketch/graphql-cache'
import { useEventDispatch } from '@sketch/utils'

declare module '@sketch/utils' {
  export interface EventsMap {
    versionIsUpdated: string
  }
}

export const useVersionUpdated = () => {
  const onVersionUpdated = useEventDispatch('versionIsUpdated')

  useVersionUpdatedSubscription({
    onSubscriptionData: ({ client, subscriptionData }) => {
      const { data, error } = subscriptionData

      if (error || !data) {
        return
      }

      onVersionUpdated(data.versionUpdated.identifier)

      const cachedVersion = client.readFragment<VersionListItemFragment>({
        fragment: VersionListItemFragmentDoc,
        fragmentName: 'VersionListItem',
        id: dataIdFromObject(data.versionUpdated)!,
      })

      if (!cachedVersion) {
        return
      }

      client.writeFragment({
        fragment: VersionListItemFragmentDoc,
        fragmentName: 'VersionListItem',
        id: dataIdFromObject(data.versionUpdated)!,
        data: data.versionUpdated,
      })
    },
  })
}
